import { render, staticRenderFns } from "./PostAttachList.vue?vue&type=template&id=12d35cca&scoped=true"
import script from "./PostAttachList.vue?vue&type=script&lang=js"
export * from "./PostAttachList.vue?vue&type=script&lang=js"
import style0 from "./PostAttachList.vue?vue&type=style&index=0&id=12d35cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d35cca",
  null
  
)

export default component.exports